// extracted by mini-css-extract-plugin
export default {"deliveryBlockTemplateContainer":"delivery-block-template-page_deliveryBlockTemplateContainer__nM0ZR"};